import { connect } from 'react-redux'
import ReportsReport from './ReportsReport'
import { getReportsReportData, setInitialReportsReportData } from './module'
import { handleOnNavClick as handleOnReportsNavClick } from '../../pages/Reports/module'

const mapActionCreators = {
  getReportsReportData,
  handleOnReportsNavClick,
  setInitialReportsReportData,
}

const mapStateToProps = state => ({
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(ReportsReport)



// WEBPACK FOOTER //
// ./src/legacy/pages/ReportsReport/container.js